import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './ImportTransactions.css';

const ImportTransactions = ({ onClose, onImportComplete }) => {
  const { authFetch } = useAuth();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [log, setLog] = useState('');

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const parseOFX = (content) => {
    // Basic OFX parser using Regex
    const transactions = [];
    const stmts = content.match(/<STMTTRN>[\s\S]*?<\/STMTTRN>/g) || [];
    
    stmts.forEach(stmt => {
      const typeMatch = stmt.match(/<TRNTYPE>(.*?)(?:\s|<)/);
      const dateMatch = stmt.match(/<DTPOSTED>(\d{8})/);
      const amtMatch = stmt.match(/<TRNAMT>(.*?)(?:\s|<)/);
      const memoMatch = stmt.match(/<MEMO>(.*?)(?:\s|<)/);
      const nameMatch = stmt.match(/<NAME>(.*?)(?:\s|<)/);
      
      const rawDate = dateMatch ? dateMatch[1] : '';
      let date = new Date().toISOString().split('T')[0];
      if (rawDate && rawDate.length >= 8) {
        date = `${rawDate.slice(0,4)}-${rawDate.slice(4,6)}-${rawDate.slice(6,8)}`;
      }

      const valStr = amtMatch ? amtMatch[1] : '0';
      const val = parseFloat(valStr) || 0;
      const desc = (memoMatch ? memoMatch[1] : (nameMatch ? nameMatch[1] : 'Lançamento OFX')).substring(0, 100);

      transactions.push({
        data: date,
        descrição: desc,
        valor: Math.abs(val),
        operacao: val >= 0 ? 'Receita' : 'Despesa',
        categoria: 'Importado',
        status: 'Pago',
      });
    });
    return transactions;
  };

  const processFile = async () => {
    if (!file) return;
    setLoading(true);
    setLog('Processando arquivo...');

    const reader = new FileReader();
    reader.onload = async (e) => {
      const text = e.target.result;
      
      let transactions = [];
      const isOFX = file.name.toLowerCase().endsWith('.ofx');
      
      if (isOFX) {
        transactions = parseOFX(text);
      } else {
        const lines = text.split('\n').filter(l => l.trim());
        for (let i = 1; i < lines.length; i++) {
          const columns = lines[i].split(',').map(c => c.trim().replace(/^"|"$/g, ''));
          if (columns.length < 3) continue;

          let [dataStr, descStr, valorStr] = columns;
          
          let date = new Date().toISOString().split('T')[0];
          if (dataStr.includes('/')) {
            const [d, m, y] = dataStr.split('/');
            if (y && y.length === 4) date = `${y}-${m.padStart(2,'0')}-${d.padStart(2,'0')}`;
          } else if (dataStr.match(/^\d{4}-\d{2}-\d{2}/)) {
            date = dataStr;
          }

          let val = parseFloat(valorStr.replace(',', '.'));
          if (isNaN(val)) val = 0;

        const isIncome = val >= 0;
        const absVal = Math.abs(val);

          transactions.push({
            data: date,
            descrição: descStr || 'Lançamento Importado',
            valor: absVal,
            operacao: isIncome ? 'Receita' : 'Despesa',
            categoria: 'Importado',
            status: 'Pago',
          });
        }
      }

      if (transactions.length === 0) {
        setLog('❌ Nenhum registro válido encontrado no arquivo.');
        setLoading(false);
        return;
      }

      setLog(`Lidos ${transactions.length} registros. Enviando...`);
      let importedCount = 0;
      let errorCount = 0;

      for (const t of transactions) {
        try {
          const res = await authFetch('/api/transactions', { method: 'POST', body: JSON.stringify(t) });
          if (res.ok) importedCount++;
          else errorCount++;
        } catch {
          errorCount++;
        }
      }

      setLog(`✅ Importação concluída! Sucesso: ${importedCount} | Falhas: ${errorCount}`);
      setLoading(false);
      
      if (importedCount > 0) {
        setTimeout(() => {
          onImportComplete();
          onClose();
        }, 3000);
      }
    };
    reader.readAsText(file);
  };

  return (
    <div className="import-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="import-modal">
        <div className="import-header">
          <h2>📥 Importar CSV (Extrato)</h2>
          <button className="modal-close-btn" onClick={onClose} disabled={loading}>✕</button>
        </div>
        
        <div className="import-body">
          <p className="import-hint">
            Selecione um arquivo <strong>.ofx</strong> ou <strong>.csv</strong> gerado pelo seu banco:
            <br/><br/>
            <strong>Se for CSV:</strong> As colunas devem ser <code>Data, Descrição, Valor</code> (separadas por vírgula).<br/>
            <strong>Se for OFX:</strong> Será lido automaticamente o padrão bancário.
          </p>

          <div className="import-file-box">
            <input type="file" accept=".csv,.ofx" onChange={handleFileChange} disabled={loading} />
          </div>

          {log && <div className="import-log">{log}</div>}
        </div>

        <div className="import-footer">
          <button className="import-btn-cancel" onClick={onClose} disabled={loading}>Cancelar</button>
          <button className="import-btn-save" onClick={processFile} disabled={!file || loading}>
            {loading ? 'Processando...' : 'Iniciar Importação'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImportTransactions;
